bindMenuCloseDirective.DIRECTIVE_NAME = 'bindMenuClose';

bindMenuCloseDirective.$inject = [
  '$ionicHistory',
  '$timeout',
  '$parse',
];

// based on https://github.com/ionic-team/ionic-v1/blob/master/js/angular/directive/menuClose.js
// bind function to scope for injection into react
export function bindMenuCloseDirective(
  $ionicHistory,
  $timeout,
  $parse,
) {
  return {
    restrict: 'AC',
    link: function (scope, element, attr) {

      // Mirroring ngClick implementation
      const bindMenuClose = $parse(attr.bindMenuClose, /* interceptorFn */ null, /* expensiveChecks */ true);

      bindMenuClose(scope, {
        $closeMenu: closeMenu,
      });

      function closeMenu() {
        const sideMenuCtrl = element.inheritedData('$ionSideMenusController');
        if (sideMenuCtrl) {
          $ionicHistory.nextViewOptions({
            historyRoot: true,
            disableAnimate: true,
            expire: 300
          });
          // if no transition in 300ms, reset nextViewOptions
          // the expire should take care of it, but will be cancelled in some
          // cases. This directive is an exception to the rules of history.js
          $timeout(function () {
            $ionicHistory.nextViewOptions({
              historyRoot: false,
              disableAnimate: false
            });
          }, 300);
          sideMenuCtrl.close();
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-delegates/bindMenuCloseDirective.js